// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__H-1KM","heading":"Terms_heading__mWrwx","subheading":"Terms_subheading__Tu1-+","bulletPoints":"Terms_bulletPoints__cnh4k"};